import { render } from "./CompanyBankAccountsPanel.vue?vue&type=template&id=15d86dad&scoped=true"
import script from "./CompanyBankAccountsPanel.vue?vue&type=script&lang=js"
export * from "./CompanyBankAccountsPanel.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "./CompanyBankAccountsPanel.vue?vue&type=style&index=1&id=15d86dad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d86dad"]])

export default __exports__